exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.guides[data-v-1d865458] {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  z-index: 999;\n  top: 0;\n  left: 0;\n}\n.verti[data-v-1d865458] {\n  position: absolute;\n  width: 1px;\n  height: 1000%;\n  top: -50px;\n  background: #18ffff;\n}\n.horiz[data-v-1d865458] {\n  position: absolute;\n  height: 0.5px;\n  width: 1000%;\n  left: -500%;\n  background: #18ffff;\n}\n", ""]);

// exports
